import type { Key } from "react";
import type {
  ICreateMode,
  IChangingMode,
  IServiceProfileFieldName,
  IServiceProfileFieldNameRule,
} from "../../../../../lib/types";
import { OFFER_STATUSES } from "../../../../../store/slices/offering/const";

const { PREPARE, SUSPENDED, ACTIVE } = OFFER_STATUSES;

// Template
// create: {
//   [PREPARE]: ,
//   [SUSPENDED]: ,
//   [ACTIVE]: ,
//   [ARCHIVE]: ,
// },

// Обязательность полей к заполенению по схеме: имя поля => режим измененения => статус предложения => правило доступности
export const isFieldRequired = (params: {
  fieldName: IServiceProfileFieldName;
  viewMode: ICreateMode | IChangingMode;
  offeringStatusId: number;
  options?: { [key: Key]: any };
}): boolean => {
  const { fieldName, viewMode, offeringStatusId, options } = params;
  const fieldNameRules: IServiceProfileFieldNameRule = {
    id: {
      create: {
        [PREPARE]: options?.isCommonType,
      },
      edit: {
        [PREPARE]: options?.isCommonType,
        [SUSPENDED]: options?.isCommonType,
      },
      add: {
        [PREPARE]: options?.isCommonType,
        [SUSPENDED]: options?.isCommonType,
      },
    },
    profileTypeId: {},
    paymentTypeId: {
      create: {
        [PREPARE]: !options?.isCommonType,
      },
      edit: {
        [PREPARE]: !options?.isCommonType,
        [SUSPENDED]: !options?.isCommonType,
      },
      add: {
        [PREPARE]: !options?.isCommonType,
        [SUSPENDED]: !options?.isCommonType,
        [ACTIVE]: !options?.isCommonType,
      },
    },
    prepaymentToPayDays: {
      create: {
        [PREPARE]: !options?.isCommonType,
      },
      edit: {
        [PREPARE]: !options?.isCommonType,
        [SUSPENDED]: !options?.isCommonType,
      },
      add: {
        [PREPARE]: !options?.isCommonType,
        [SUSPENDED]: !options?.isCommonType,
        [ACTIVE]: !options?.isCommonType,
      },
    },
    invoicePeriodId: {
      create: {
        [PREPARE]: !options?.isCommonType,
      },
      edit: {
        [PREPARE]: !options?.isCommonType,
        [SUSPENDED]: !options?.isCommonType,
      },
      add: {
        [PREPARE]: !options?.isCommonType,
        [SUSPENDED]: !options?.isCommonType,
        [ACTIVE]: !options?.isCommonType,
      },
    },
    billToPayDays: {
      create: {
        [PREPARE]: !options?.isCommonType,
      },
      edit: {
        [PREPARE]: !options?.isCommonType,
        [SUSPENDED]: !options?.isCommonType,
      },
      add: {
        [PREPARE]: !options?.isCommonType,
        [SUSPENDED]: !options?.isCommonType,
        [ACTIVE]: !options?.isCommonType,
      },
    },
    prepaymentPeriodId: {
      create: {
        [PREPARE]: !options?.isCommonType,
      },
      edit: {
        [PREPARE]: !options?.isCommonType,
        [SUSPENDED]: !options?.isCommonType,
      },
      add: {
        [PREPARE]: !options?.isCommonType,
        [SUSPENDED]: !options?.isCommonType,
        [ACTIVE]: !options?.isCommonType,
      },
    },
    billPeriodId: {
      create: {
        [PREPARE]: !options?.isCommonType,
      },
      edit: {
        [PREPARE]: !options?.isCommonType,
        [SUSPENDED]: !options?.isCommonType,
      },
      add: {
        [PREPARE]: !options?.isCommonType,
        [SUSPENDED]: !options?.isCommonType,
        [ACTIVE]: !options?.isCommonType,
      },
    },
    fromDate: {
      add: {
        [PREPARE]: true,
        [SUSPENDED]: true,
      },
    },
    toDate: {},
  };
  return Boolean(fieldNameRules[fieldName]?.[viewMode]?.[offeringStatusId]);
};
